import { z } from 'zod';

export const ArchiveSearchReqSchema = z.object({
  query: z.string(),
  limit: z.number().int().optional(),
});

export type ArchiveSearchReq = z.infer<typeof ArchiveSearchReqSchema>;

export const RoleSchema = z.enum([
  '',
  'customer',
  'co-customer',
  'person',
  'co-person',
]);

export type Role = z.infer<typeof RoleSchema>;

export const ArchiveResultSchema = z.object({
  Role: RoleSchema,
  LoanApplicationID: z.string(),
  HumanReadableID: z.string(),
  CreatedAt: z.string(),
  UpdatedAt: z.string(),
  CompletedAt: z.string().optional(),
  Status: z.string(),
  MarketCountry: z.string(),
  Product: z.string(),
  Broker: z.string(),
  Amount: z.number(),
});

export type ArchiveResult = z.infer<typeof ArchiveResultSchema>;

export const ArchiveSearchResSchema = z.object({
  Sketchy: z.boolean(),
  Items: z.array(ArchiveResultSchema).nullable(),
});

export type ArchiveSearchRes = z.infer<typeof ArchiveSearchResSchema>;
